import React from "react";

export default () => {
  return (
    <React.Fragment>
      <footer>
        <h3 className="text-center text-lg font-semibold">
          GitJobs Act | Created by <span> </span>
          <a
            href="https://github.com/ref-bit"
            className="text-blue-500 hover:text-black transition duration-500"
            target="_blank"
            rel="noopener noreferrer"
          >
            Ref-Bit
          </a>
        </h3>
      </footer>
    </React.Fragment>
  );
};
